import React, { useState, useEffect } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from './messages'
import useApi from 'hooks/useApi'

const Brand = ({ customerId }) => {
  const [brand, loading, errors, refetch] = useApi(`/rest/v1/customer/${customerId}/brand`)
  const [updatedBrand, updating, updateErrors, update] = useApi(`/rest/v1/customer/${customerId}/brand`, { method: 'PUT', load: false })

  const [customMessages, setCustomMessages] = useState({
    'containers.CustomerHomePage.callToAction': '',
    'containers.CustomerHomePage.callToAction.href': '',
    'containers.CustomerHomePage.callToAction.secondary': '',
    'containers.CustomerHomePage.callToAction.secondary.href': '',
  })

  const messagesMessages = {
    'containers.CustomerHomePage.callToAction': ['Primary CTA', 'Contact'],
    'containers.CustomerHomePage.callToAction.href': ['Primary CTA Link', 'https://voicearchive.com/contact'],
    'containers.CustomerHomePage.callToAction.secondary': ['Secondary CTA Link', '+ New Project'],
    'containers.CustomerHomePage.callToAction.secondary.href': ['Secondary CTA Link', 'https://voicearchive.com/en/voicefinder/search'],
  }

  useEffect(() => setCustomMessages(Object.assign(customMessages, brand ? brand.messages : {})), [brand])
  useEffect(() => setCustomMessages(Object.assign(customMessages, updatedBrand ? updatedBrand.messages : {})), [updatedBrand])

  const onSave = () => {
    update({ json: { messages: customMessages } })
    refetch()
  }

  return (
    <div className="w-full">
      <div className="w-full border border-gray-300 p-4 bg-white">
        <div className="text-gray-400"><FormattedMessage {...messages.links} /></div>
        <p className="border border-yellow-300 bg-yellow-100 p-2 mt-2">
          <FormattedMessage {...messages.linksHint} />
        </p>

        { Object.entries(customMessages).map(([id, message]) => (
          <div key={id} className="w-full mt-4">
            <div className="text-gray-700 text-sm font-bold">{Array.isArray(messagesMessages[id]) ? messagesMessages[id][0] : id }</div>
            <input
              className="w-full h-8 border border-gray-100 px-2"
              value={message}
              placeholder={Array.isArray(messagesMessages[id]) ? messagesMessages[id][1] : ''}
              onChange={({ target }) => setCustomMessages((prev) => ({ ...prev, [id]: target.value }))}
            />
          </div>
        )) }

      </div>

      <div className="flex mt-3 justify-end">
        { updating ? (
          <button className="px-6 py-3 text-white font-medium uppercase" style={{ background: '#9ece00' }}>
            <i className="fa fa-save" /> Saving..
          </button>
        ) : (
          <button className="px-6 py-3 text-white font-medium uppercase" style={{ background: '#9ece00' }} onClick={onSave}>
            <i className="fa fa-save" /> Save
          </button>
        ) }
      </div>
    </div>
  )
}

export default Brand
